<template>
  <div class="action-button-container">
    <BbBtn
      :class="['action-button', { 'action-button__active': showMenu }]"
      size="small"
      type="secondary"
      @click="$emit('handle-menu', true)"
    >
      <div>
        <div class="filters-selected-label" v-if="expandedFilters">
          <TextBody :text="title" />
        </div>
        <div class="filters-selected-title">
          <div v-if="numberOfSelectedValues && !expandedFilters" class="filters-selected-icon" />
          <TextBody :text="subtitle" />
        </div>
      </div>
      <BbTooltip
        v-if="showMenu && numberOfSelectedValues"
        v-bind="{ placement: 'top', offset: 4, isDisabled: false, content: t('author.filters.removeAll') }"
      >
        <BbBtn
          class="clear-button"
          size="x-small"
          type="icon"
          icon="x-small"
          icon-size="medium"
          no-background
          @click="$emit('clear-filters')"
        />
      </BbTooltip>
    </BbBtn>
  </div>
  <div class="popover-wrapper">
    <slot />
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';

import useAuthoring from '~/composables/useAuthoring';
import TextBody from '~/components/common/TextBody.vue';

export default {
  components: { TextBody },
  emits: ['handle-menu', 'clear-filters'],
  props: {
    showMenu: {
      type: Boolean,
      default: false,
    },
    numberOfSelectedValues: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
  setup() {
    const { t } = useI18n();
    const { expandedFilters } = useAuthoring();

    return { t, expandedFilters };
  },
};
</script>

<style scoped lang="scss">
.popover-wrapper {
  margin-top: 52px !important;
}

.action-button-container {
  width: 100%;
  height: 100%;

  .clear-button {
    border-radius: 50% !important;

    :deep(.v-btn__content) {
      color: $bb-primary-3;
    }

    &:hover {
      background: $bb-neutral-5;
    }
  }

  .action-button {
    width: 100% !important;
    height: 100% !important;
    background: inherit;
    border: unset !important;
    font-size: 15px;
    font-weight: 500;
    color: $bb-neutral-1;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    &:focus,
    &__active {
      background: $bb-neutral-0 !important;
      border-radius: 50px;
      border: 1px solid $bb-neutral-4 !important;
      box-shadow: 0px 4.923px 7.876px 0px rgba(0, 0, 0, 0.1) !important;
    }

    :deep(.bb-btn.secondary) {
      background: $bb-neutral-5;
      border-radius: 0;
      height: 68px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 15px;
      font-weight: 500;
      color: $bb-neutral-1;
      margin-top: 9px;
      margin-left: 7px;
    }

    :deep(.bb-btn.secondary):hover {
      background: $bb-neutral-0 !important;
      border-radius: 50px;
      border: 1px solid $bb-neutral-4 !important;
      box-shadow: 0px 4.923px 7.876px 0px rgba(0, 0, 0, 0.1) !important;
    }

    :deep(.v-btn__content) {
      display: flex;
      justify-content: space-between;
      width: 100%;
      align-items: center;
    }

    .filters-selected-label {
      font-size: 15px !important;
      color: $bb-neutral-2 !important;
      text-align: start;
    }

    .filters-selected-title {
      color: $bb-neutral-1 !important;
      font-weight: 500;
      font-size: 15px;
      margin-top: 2px;
      display: flex;
      align-items: center;
      gap: 6px;

      .filters-selected-icon {
        content: url('@/assets/svg/selected-check.svg');
      }
    }
  }
}
</style>
